/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SalesArticleStock } from '../../models/sales-article-stock';

export interface FindStock$Params {

/**
 * Id of the inventory to retrieve stock.
 */
  inventoryId: string;

/**
 * Ids of the sales articles to retrieve stock.
 */
  salesArticleIds: Array<string>;
}

export function findStock(http: HttpClient, rootUrl: string, params: FindStock$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleStock>>> {
  const rb = new RequestBuilder(rootUrl, findStock.PATH, 'get');
  if (params) {
    rb.query('inventoryId', params.inventoryId, {});
    rb.query('salesArticleIds', params.salesArticleIds, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SalesArticleStock>>;
    })
  );
}

findStock.PATH = '/api/visits/stock';
